import { createSlice } from '@reduxjs/toolkit';
import { REDUX_OPERATIONS } from '../reduxConstants';

const initialState = {
  diagnosis: [],
  procedure: [],
};

const claimSlice = createSlice({
  name: 'claimSlice',
  initialState,
  reducers: {
    setProcedureDiagnosis: (state, action) => {
      let diagnosisList = [...state.diagnosis];
      if (
        action.payload?.operation === REDUX_OPERATIONS.UPDATE &&
        diagnosisList.some(s => s.sequence === action.payload?.sequence)
      ) {
        diagnosisList[
          diagnosisList.findIndex(f => f.sequence === action.payload?.sequence)
        ] = action.payload?.diagnosis;
      } else if (action.payload?.operation === REDUX_OPERATIONS.DELETE) {
        let procedureList = [...state.procedure];
        procedureList.forEach((procedure, idx) => {
          if (
            procedure?.mapped_diagnosis.some(
              s => s.sequence === action.payload?.sequence
            )
          ) {
            procedureList[idx].mapped_diagnosis = procedure?.mapped_diagnosis
              .filter(s => s.sequence !== action.payload?.sequence)
              .map((m, idx) => {
                return {
                  ...m,
                  sequence: idx + 1,
                };
              });
          }
        });
        state.procedure = [...procedureList];
        diagnosisList = diagnosisList.filter(
          f => f.sequence !== action.payload?.sequence
        );
      } else if (action.payload?.operation === REDUX_OPERATIONS.ADD) {
        diagnosisList.push(action.payload.diagnosis);
      }
      state.diagnosis = [
        ...diagnosisList.map((d, idx) => {
          return {
            ...d,
            sequence: idx + 1,
          };
        }),
      ];
    },
    setProcedure: (state, action) => {
      let procedureList = [...state.procedure];
      if (
        action.payload?.operation === REDUX_OPERATIONS.UPDATE &&
        procedureList.some(s => s.sequence === action.payload?.sequence)
      ) {
        procedureList[
          procedureList.findIndex(f => f.sequence === action.payload?.sequence)
        ] = action.payload?.data;
      } else if (action.payload?.operation === REDUX_OPERATIONS.DELETE) {
        procedureList = procedureList.filter(
          f => f.sequence !== action.payload?.sequence
        );
      } else if (action.payload?.operation === REDUX_OPERATIONS.ADD) {
        procedureList.push(action.payload.data);
      }
      state.procedure = [
        ...procedureList.map((d, idx) => {
          return {
            ...d,
            sequence: idx + 1,
          };
        }),
      ];
    },
    clearDiagnosisAndProcedure: state => {
      state.diagnosis = [];
      state.procedure = [];
    },
  },
});

export const {
  setProcedureDiagnosis,
  setProcedure,
  clearDiagnosisAndProcedure,
} = claimSlice.actions;
export default claimSlice.reducer;
